module.exports = __webpack_public_path__ + "img/internet8.47fedc44.png";